import cacheLs from "../cacheLs"

export default {
  addUserRole (state, data) {
    state.selectedUserRole = { ...data }
    cacheLs.set_user_role(data)
  }
}
